import React from 'react';

import style from './Label.module.scss';

const Label = ({ tags, classname }) => (
  <div className={style.labelContainer}>
    {tags.map((label) => (
      <span className={`${style.labelDiv} ${classname}`} key={`tag-${label}`}>
        {label}
      </span>
    ))}
  </div>
);

export default Label;
